import RestService from './RestService';
import { ApiRoutes } from './apiRoutes';
import { ProductListResponseItem } from 'types/ProductListTypes';
import type { ProductDisplayData, ProductDisplayRequestItem } from 'types/ProductTypes';

export const ConstraintsService = {
  searchMicroCategories: async (microCategorySearchString: string): Promise<any[]> => {
    return RestService.get(ApiRoutes.SEARCH_MICROCATEGORIES(microCategorySearchString));
  },
  searchProducts: async (productSearchString: string): Promise<any[]> => {
    return RestService.get(ApiRoutes.SEARCH_PRODUCTS(productSearchString));
  },

  async getMicrocategoryNames(): Promise<Record<string, string>> {
    return RestService.get(ApiRoutes.MICROCATEGORY_NAMES);
  },

  async getProductNames(isins: string[]): Promise<Record<string, string>> {
    return RestService.get(ApiRoutes.PRODUCT_NAMES(isins));
  },

  async getProductLists(): Promise<ProductListResponseItem[]> {
    return RestService.get(ApiRoutes.PRODUCT_LISTS);
  },

  async createProductList(data: { name: string; isins: string[] }): Promise<ProductListResponseItem> {
    return RestService.post(
      ApiRoutes.CREATE_PRODUCT_LIST,
      data,
      { suppressGlobalErrorToast: true },
    );
  },

  async updateProductList(
    listId: string,
    data: { name?: string; isins?: string[] }
  ): Promise<ProductListResponseItem> {
    return RestService.put(
      ApiRoutes.UPDATE_PRODUCT_LIST(listId),
      data,
      { suppressGlobalErrorToast: true },
    );
  },

  async deleteProductList(listId: string): Promise<void> {
    return RestService.delete(ApiRoutes.DELETE_PRODUCT_LIST(listId));
  },

  async fetchConstraintsDefault(): Promise<any> {
    return RestService.get(ApiRoutes.CONSTRAINTS_DEFAULT);
  },
  fetchPtf: async (portfolioId: any): Promise<any> => {
    return RestService.get(ApiRoutes.FINECO_PORTFOLIO_PTF(portfolioId));
  },

  /**
   * Fetch display data (label, currency, hold modes) for products by ISINs.
   * Pass investment_type per item when available — backend uses it for operational-lock
   * matrix lookups. Omitting it falls back to consultability-only logic.
   */
  async getProductDisplayData(
    items: ProductDisplayRequestItem[]
  ): Promise<ProductDisplayData[]> {
    const response = await RestService.post<{ products: ProductDisplayData[] }>(
      ApiRoutes.PRODUCT_DISPLAY,
      { items }
    );
    return response.products;
  },
};
